export default __webpack_public_path__ + "static/media/12.cf5d5fd1.jpg";